"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SGMutateMaterial = exports.PricingDataTransport = exports.MaterialPricingTransport = exports.PricingSizeDataTransport = exports.TypeOfPricing = exports.TypesOfPricingLabels = exports.TypesOfPricing = void 0;
const typebox_1 = require("@sinclair/typebox");
const nullable_1 = require("../common/nullable");
exports.TypesOfPricing = ['ton', 'flat', 'yard'];
exports.TypesOfPricingLabels = {
    ton: 'Ton',
    flat: 'Flat',
    yard: 'Yard',
};
exports.TypeOfPricing = typebox_1.Type.Union(exports.TypesOfPricing.map((value) => typebox_1.Type.Literal(value)));
exports.PricingSizeDataTransport = typebox_1.Type.Object({
    dump: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Number())),
    dumpDollars: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Number())),
    over: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Number())),
    overDollars: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Number())),
    size: typebox_1.Type.String(),
    haul: typebox_1.Type.Optional(typebox_1.Type.Number()),
    haulDollars: typebox_1.Type.Optional(typebox_1.Type.Number()),
    tonLimit: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.Number())),
});
exports.MaterialPricingTransport = typebox_1.Type.Object({
    id: typebox_1.Type.Optional(typebox_1.Type.String()),
    material: typebox_1.Type.String(),
    tax: typebox_1.Type.Boolean(),
    type: typebox_1.Type.String(),
    sizes: typebox_1.Type.Array(exports.PricingSizeDataTransport),
    allowOnlineCheckout: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    allowForLowerTonLimit: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    doesNotService: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    haulerApproved: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    sourgumApproved: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    effectiveDate: typebox_1.Type.Optional(typebox_1.Type.String()),
    expirationDate: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedAt: typebox_1.Type.String(),
});
/** @deprecated Renamed to MaterialPricingTransport instead */
exports.PricingDataTransport = exports.MaterialPricingTransport;
exports.SGMutateMaterial = typebox_1.Type.Object({
    details: typebox_1.Type.Intersect([
        exports.MaterialPricingTransport,
        typebox_1.Type.Object({
            customerDiscountApplied: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
            discountCustomerID: typebox_1.Type.Optional(typebox_1.Type.String()),
        }),
    ]),
    effectiveDate: typebox_1.Type.String(),
    expirationDate: typebox_1.Type.Optional((0, nullable_1.Nullable)(typebox_1.Type.String())),
});
//# sourceMappingURL=pricing-data-transport.js.map